// The quiet read-out under the "Changes" view: three stats, a legend, and how it was measured.
import { LEGEND, changeStats, methodLine } from './site3dChange';
import { F } from './siteUi';

export default function ChangeSummary({ t, result }) {
  if (!result) {
    return <p data-testid="change-summary" aria-live="polite" style={{ margin: '16px 0 0', fontSize: 14, color: t.mute }}>Measuring changes…</p>;
  }
  if (result.error) {
    return <p data-testid="change-summary" role="status" style={{ margin: '16px 0 0', fontSize: 14, color: t.mute }}>{result.error}</p>;
  }
  const stats = changeStats(result.summary);
  return (
    <div data-testid="change-summary" style={{ marginTop: 20, fontFamily: F.display }}>
      <dl style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 16, margin: 0, paddingBottom: 16, borderBottom: `1px solid ${t.hair}` }}>
        {stats.map((s) => (
          <div key={s.key} data-testid={`change-${s.key}`} style={{ minWidth: 0 }}>
            <dt style={{ fontSize: 13, color: t.mute }}>{s.label}</dt>
            <dd style={{ margin: '4px 0 0', fontSize: 20, fontWeight: 500, color: t.ink, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{s.value}</dd>
          </div>
        ))}
      </dl>
      <ul aria-label="Colours" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 20px', listStyle: 'none', margin: '16px 0 0', padding: 0, fontSize: 13.5, color: t.ink2 }}>
        {LEGEND.map((l) => (
          <li key={l.key} style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <span aria-hidden style={{ width: 12, height: 12, borderRadius: 1, background: l.color }} />{l.label}
          </li>
        ))}
      </ul>
      <p style={{ margin: '12px 0 0', fontSize: 13, lineHeight: 1.5, color: t.mute, maxWidth: 640 }}>{methodLine(result.summary)}</p>
    </div>
  );
}
